import {Component} from '@angular/core';
import {
  DatatableActionButton,
  DatatableEvent,
  DatatableHandler,
  DatatableHandlerSettings,
  IconType,
} from '../../../components/datatables/datatable/datatable/datatable.component';
import {DataTableRoutes} from '../../../constants/datatableUrls';
import {Title} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {TenantService} from '../../../services/tenant.service';
import {ConfirmModalComponent} from '../../../components/modals/confirm-modal/confirm-modal.component';
import {SimpleModalService} from 'ngx-simple-modal';
import {TenantsClient} from '../../../generated-client/generated-api-client';
import {ToastrService} from 'ngx-toastr';
import {ErrorProcessorService} from '../../../services/error-processor.service';
import { PersistentDataService } from '../../../services/persistent-data.service';

@Component({
  selector: 'app-tenant-list',
  templateUrl: './tenant-list.component.html',
  styleUrls: ['./tenant-list.component.sass'],
})
export class TenantListComponent {
  private _dtActionButtonsFn: (data: any) => DatatableActionButton[] = data => {
    const id = data['id'];
    const isArchived = data['isArchived'];

    const archiveAction = isArchived
      ? new DatatableActionButton('unArchive', 'Terület aktiválása', 'unarchive', undefined, IconType.Danger)
      : new DatatableActionButton('archive', 'Terület archiválása', 'archive', undefined, IconType.Success);

    const editUrl = `/tenants/${id}`;
    const editAction = new DatatableActionButton('edit', 'Terület módosítása', 'edit', editUrl);
    return [editAction, archiveAction];
  };

  dtHandler?: DatatableHandler;
  dtSettings: DatatableHandlerSettings = DatatableHandler.getDefaultSettings();
  dtDataSourceUrl: string = DataTableRoutes.TenantsList;

  constructor(
    private titleService: Title,
    private router: Router,
    private _tenantService: TenantService,
    private _modalService: SimpleModalService,
    private _tenantsClient: TenantsClient,
    private toastr: ToastrService,
    private errorProcessorService: ErrorProcessorService,
    private _pDservice: PersistentDataService
  ) {
    this.titleService.setTitle('Területek');

    this.dtSettings.buttons = [
      {
        text: 'Új terület',
        class: 'btn-primary text-white',
        url: '/tenants/new',
      },
    ];
    this.dtSettings.actions = this._dtActionButtonsFn;
    this.dtSettings.pageSize = _pDservice.tanentPageSize;
    this.dtSettings.searchString = _pDservice.tanentSearchString;

    this.dtSettings.additionalRequestData = () => {
      if (this.dtHandler?.pageSize != null)
        _pDservice.tanentPageSize = this.dtHandler?.pageSize
      if (this.dtHandler?.searchString != null)
        _pDservice.tanentSearchString = this.dtHandler?.searchString
      return {
        tenantId: this._tenantService.activeTenantId,
      };
    };

    this._tenantService.tenantId.subscribe(tenantId => {
      this.dtHandler?.refresh();
    });
  }

  onDtInit(dtHandler: DatatableHandler): void {
    this.dtHandler = dtHandler;
    this.dtHandler.create();
  }

  onDtAction(event: DatatableEvent) {
    if (event.actionId === 'archive') {
      this.archive(event.data['id']);
    }
    if (event.actionId === 'unArchive') {
      this.unArchive(event.data['id']);
    }
  }

  private archive(id: string): void {
    this._modalService
      .addModal(ConfirmModalComponent, {
        title: 'Terület archiválása',
        message: 'Biztosan archiválni szeretné a kiválasztott területet?',
        description:
          'A folyamat hatására az adott területtel rendelkező felhasználók elveszítik a jogosultságukat a területhez. A művelet nem visszavonható!',
        confirmText: 'Igen',
        confirmClass: 'btn-danger text-white',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          this._tenantsClient.archive(id, undefined).subscribe(
            () => {
              this.dtHandler?.refresh();
              this._tenantService.refreshTenantSelectList(this._tenantsClient);
              this.toastr.success('Sikeres archiválás');
            },
            error => this.errorProcessorService.processError(error, true)
          );
        }
      });
  }

  private unArchive(id: string): void {
    this._modalService
      .addModal(ConfirmModalComponent, {
        title: 'Terület aktiválása',
        message: 'Biztosan aktiválni szeretné a kiválasztott területet?',
        confirmText: 'Igen',
        confirmClass: 'btn-primary text-white',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          this._tenantsClient.unArchive(id, undefined).subscribe(
            () => {
              this.dtHandler?.refresh();
              this.toastr.success('Sikeres aktiválás');
            },
            error => this.errorProcessorService.processError(error, true)
          );
        }
      });
  }
}
